import React from 'react';
import { useTranslation } from 'react-i18next';
import propTypes from 'prop-types';
import { Media } from "../../AppMedia";
import { Modal, Space, Button } from 'antd';
import { ClockCircleOutlined } from '@ant-design/icons';
import { BLUE_COLOR, RED_COLOR, WHITE_COLOR } from '../../constance/color';
import ColorButton from './ColorButton';

function TimeoutModal(props) {

  const {
    open,
    onClose,
  } = props;

  const { t } = useTranslation();

  return (
    <Modal
      open={open}
      onCancel={onClose}
      size='small'
      title={
        <Space>
          <ClockCircleOutlined style={{ color: RED_COLOR, size: 'big' }} />
          {t('error_messages.session_timeout.header')}
        </Space>
      }
      footer={
        <ColorButton
          type='primary'
          override={BLUE_COLOR}
          onClick={onClose}
        >{t('confirm')}</ColorButton>
      }
    >
      {t('error_messages.session_timeout.content')}
    </Modal >
  );
}

export default React.memo(TimeoutModal);

TimeoutModal.defaultProps = {
  open: false,
  onClose: () => null,
}

TimeoutModal.propTypes = {
  open: propTypes.bool,
  onClose: propTypes.func,
}
